<template>
  <v-card id="ticket-summary" class="px-7 py-8 card-fixed-height">
    <header class="d-flex justify-space-between flex-wrap">
      <h6 class="ml-3 mb-0 mt-2 align-center body-1 font-weight-600 summary-data">
        <span class="secondary--font mr-2">Tickets Summary</span>
      </h6>
      <div class="ml-auto mr-4 align-center flex-grow-0 flex-shrink-1">
        <v-select 
          v-model="numberOfDays" 
          :items="daysFilterData" 
          placeholder="Select Filter" 
          item-text="name"
          item-value="value" 
          prepend-inner-icon="mdi-filter-variant" 
          outlined 
          dense 
          short 
          hide-details 
          attach 
          full-width
          class="select--position filter-dropdown text-capitalize body-2" 
          @change="getTicketSummary" 
        />
      </div>
    </header>
    <v-row>
      <v-col align="center">
        <span class="mr-3">
          <v-icon small color="#03B6FC">mdi-square </v-icon>
          <span class="body-2 ml-2 mr-2">Received Tickets <span class="line-vertical"></span></span>
          <span class="mr-10 summary-data">{{ receivedTickets }}</span>
        </span>
        <span class="mx-8 mr-6">
          <v-icon small color="#41CE65">mdi-square </v-icon>
          <span class="body-2 ml-2 mr-2">Resolved Tickets <span class="line-vertical"></span></span>
          <span class="summary-data">{{ resolvedTickets }}</span>
        </span>
      </v-col>
    </v-row>
    <v-card elevation="0">
      <v-row>
        <v-col cols="10" class="pa-0">
          <div>
            <div v-if="chartLoader" class="ticket-summary-chart d-flex justify-center">
              <line-chart :styles="lineStyles" :options="chartOptions" :chartdata="chartData" />
            </div>

            <div v-else class="ticket-summary-chart">
              <v-overlay :absolute="absolute" :z-index="zIndex" :value="(overlay = true)" opacity="0.2">
              </v-overlay>
            </div>
          </div>
        </v-col>
        <v-col class="mt-4 pa-0">
          <div>
            <div class="summary-label font-weight-regular primary--font d-inline-block">Average Resolution time</div>
            <div class="summary-data mt-1">{{ this.avgResolutionTime }} min</div>
          </div>
          <div class="mt-9">
            <div class="summary-label font-weight-regular primary--font d-inline-block">Average Response time</div>
            <div class="summary-data mt-1">{{ this.avgResponseTime }} min</div>
          </div>
          <div class="mt-9">
            <div class="summary-label font-weight-regular d-inline-block primary--font">Average first Response time</div>
            <div class="summary-data mt-1">{{ this.avgFirstResponse }} min</div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
import LineChart from "@/components/charts/LineChart.vue";
import { $dashboard } from "@/services/Index";

export default {
  components: {
    LineChart,
  },

  data: () => ({
    numberOfDays: 0,
    chartLoader: false,
    absolute: true,
    zIndex: 999,
    receivedTrends: [],
    resolvedTrends:[],
    daysFilterData: [
      { name: "Today", value: 0 },
      { name: "7 Days", value: 7 },
      { name: "30 Days", value: 30 },
      { name: "90 Days", value: 90 },
    ],
    chartOptions: {},
    chartData: {},
    chartLabels: [],
    selectedDay: "today_trends",
    receivedTickets: null,
    resolvedTickets: null,
    avgFirstResponse: null,
    avgResponseTime: null,
    avgResolutionTime: null,
  }),
  computed: {
    lineStyles() {
      let height = "18rem";
      let width = "95%";
      let marginTop = "15px";
      if (this.$vuetify.breakpoint.xsOnly) {
        height = "16rem";
      }
      if (this.$vuetify.breakpoint.mdAndDown) {
        width = "70%";
      }
      return {
        height,
        width,
        marginTop,
      };
    },
  },
  mounted() {
    this.intializeSummaryGraph();
  },

  methods: {
    intializeSummaryGraph() {
      this.chartData = {
        labels: [],
        datasets: [
          {
            label: "Received",
            data: [],
            fill: false,
            borderWidth:1,
            borderColor: "#03B6FC",
            backgroundColor: "#03B6FC",
            pointBorderWidth: 2,
            pointBorderColor: "#03b6fc",
            hoverBorderColor: "#02B6FC",
            pointHoverBorderColor: "#fff",
            pointHoverBackgroundColor: "#03B6FC",
            pointHoverBorderWidth: 2,
            pointStyle: "circle",
          },
          {
            label: "Resolved",
            fill: false,
            data: [],
            borderWidth:1,
            borderColor: "#41CE65",
            backgroundColor: "#41CE65",
            pointBorderWidth: 2,
            pointBorderColor: "#41CE65",
            hoverBorderColor: "#41CE65",
            pointHoverBorderColor: "#41CE65",
            pointHoverBackgroundColor: "#41CE65",
            pointHoverBorderWidth: 2,
            pointStyle: "circle",
          },
        ],
      };
      this.chartOptions = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        elements: {
          point: { radius: 3 },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: true,
                drawTicks: true,
              },
              ticks: {
                display: true,
                padding: 10,
              },
            },
          ],
          yAxes: [
            {
              position: "left",
              gridLines: {
                drawOnChartArea: true,
                drawTicks: true,
              },
              ticks: {
                precision:0,
                beginAtZero: true,
                display: true,
                padding: 10,
              },
            },
          ],
        },
        tooltips: {
          mode: "index",
          backgroundColor: "#E8E5E5",
          titleFontColor: "black",
          titleFontSize: 0,
          bodyFontColor: "black",
          bodyAlign: "left",
          position:'nearest',
          titleMarginBottom:0,
        },
        layout:{
          padding:{
            top:5,
            bottom:20,
          }
        }
      };
      this.getTicketSummary();
    },

    lastNDays(alterFilter) {
      var result = []
      for (var i = 0; i < this.numberOfDays; i++) {
        var d = new Date()
        d.setDate(d.getDate() - i)
        result.push(
          this.$options.filters.formatDate(
            d,
            alterFilter ? 'YYYY-MM-DD' : 'DD MMM',
          ),
        )
      }
      return result
    },

    setLabels() {
      if (this.numberOfDays > 0) {
        this.chartData.labels = this.lastNDays(false).reverse();
      } else {
        this.chartData.labels = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
      }
    },

    /** get ticket by summary from API's */
    async getTicketSummary() {
      this.chartLoader = false;
      this.setLabels();
      try {
        const response = await $dashboard.ticketSummary({ params: { limit: this.numberOfDays } });
        if (response.data) {
          this.receivedTickets = response.data.stats.received_tickets;
          this.resolvedTickets = response.data.stats.resolved_tickets;
          this.avgFirstResponse = response.data.stats.avg_first_response_time || "00:00";
          this.avgResponseTime = response.data.stats.avg_response_time || "00:00";
          this.avgResolutionTime =response.data.stats.avg_resolution_time || "00:00";
          for (let i = 0; i < this.chartData.datasets[0].data.length; i++) {
            this.chartData.datasets[0].data[i] = 0;
            this.chartData.datasets[1].data[i] = 0;
          }
          this.setDataInGraph(response.data);
          this.chartLoader = true;
        }
      } catch (error) {
        console.log("error==", error);
        this.chartLoader = true;
      }
    },

    /** setting ticket By summary data in line chart */
    setDataInGraph(data) {
      this.chartData.datasets[0].data = Array(this.numberOfDays).fill(0);
      this.chartData.datasets[1].data = Array(this.numberOfDays).fill(0);
      this.receivedTrends = data.ticket_summary.received;
      this.resolvedTrends = data.ticket_summary.resolved;
      this.chartLabels = this.chartData.labels;
      this.receivedTrends = data.ticket_summary.received;
      this.chartData.datasets[0].data = this.chartLabels.map(label => this.receivedTrends[label] || 0);
      this.resolvedTrends = data.ticket_summary.resolved;
      this.chartData.datasets[1].data = this.chartLabels.map(label => this.resolvedTrends[label] || 0);
    },
  },
};
</script>

<style lang="scss">
.card-fixed-height {
  height: 460px;
}

.left-border {
  border-left: 2px solid grey;
}

.ticket-summary-chart {
  height: 279px !important;
  width:100%;
  padding-right: 21px;
}

.summary-label{
  color: rgba(0,0,0,0.6);
  height: 20px;
  letter-spacing: 0.25px;
  font-size: 14px;
}
.summary-data{
  font-family: Montserrat;
  font-weight: 600;
  height: 24px;
  color: rgba(0,0,0,0.87);
  letter-spacing: 0.55px;
  font-size: 16px;
}

.line-vertical{
  display: inline-block;
  width: 1px; 
  height: 22px; 
  background-color: rgba(222, 222, 222, 1); 
  margin: 0 5px;
  vertical-align: middle; 
}

.select--position{
  width: 257px;
  height: 86px;
}
</style>



